export default "__VITE_ASSET__DEQTSi6P__"